import { IConnection } from "src/app/models/connection";
export const ConnectionState: IConnection = {
  connected: false,
};
